var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdCalendarIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.5C4 2.22386 4.22386 2 4.5 2C4.77614 2 5 2.22386 5 2.5V3.5C5 3.77614 4.77614 4 4.5 4C4.22386 4 4 3.77614 4 3.5V2.5Z",
    fill: "#686B7C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.5C9 2.22386 9.22386 2 9.5 2C9.77614 2 10 2.22386 10 2.5V3.5C10 3.77614 9.77614 4 9.5 4C9.22386 4 9 3.77614 9 3.5V2.5Z",
    fill: "#686B7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19995 3H5.79995V3.50001C5.79995 4.21798 5.21792 4.80001 4.49995 4.80001C3.78198 4.80001 3.19995 4.21798 3.19995 3.50001V3H3C2.44772 3 2 3.44772 2 4V6H12V4C12 3.44772 11.5523 3 11 3H10.8V3.50001C10.8 4.21798 10.2179 4.80001 9.49995 4.80001C8.78198 4.80001 8.19995 4.21798 8.19995 3.50001V3Z",
    fill: "#686B7C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7H12V11C12 11.5523 11.5523 12 11 12H3C2.44772 12 2 11.5523 2 11V7Z",
    fill: "#686B7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdCalendarIco);
export default __webpack_public_path__ + "static/media/ad_calendar_ico.168e77e978dcae2f0592480e93bfe923.svg";
export { ForwardRef as ReactComponent };